import { sagaCreator } from '@adrias-online/steiner';
import helper from 'helpers/steinerHelper';

import { actions, actionTypes } from '../actions/cookieConfig';
import { selectors, DEFAULT_STATE } from '../reducers/cookieConfig';
import api from '../apis/cookieConfig';

const sagas = helper.createSagas(
    'cookieConfig',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        numberFilters: ['hotelId']
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
